import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SendIcon from '@mui/icons-material/Send';
import { API_URL } from '../../Constants';

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

let apiUrl = API_URL;



export default function InProcessCredit() {

    const [data, setData] = useState([]);
    const [commerceName, setCommerceName] = useState('');

    useEffect(() => {
        if (localStorage.getItem('commerceUuid') == null) {
            window.location = '/';
        }


        fetch(apiUrl + '/v1/feasibility-inquiries/commerce-in-process/' + localStorage.getItem('commerceUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setData(res);
                })
            } else {
                alert("CommerceUuid Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });

        fetch(apiUrl + '/v1/commerces/' + localStorage.getItem('commerceUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setCommerceName(res.name);
                })
            } else {
                alert("CommerceUuid Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });


    }, [])

    const handleQuotaSimulator = (feasibilityUuid, clientUuid) => {
        localStorage.setItem("clientUuid", clientUuid);
        localStorage.setItem("feasibilityUuid", feasibilityUuid)
        window.location = '/quota-simulator';
    }

    const handleLogOut = () => {
        localStorage.clear();
        window.location = '/commerce-loggin';
    }

    const handleBackToHome = () => {
        window.location = '/commerce';
    }
    

    return (
        <React.Fragment>
            <Header />
            <Container maxWidth="lg">
                <br />
                <br />
                <br />
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs />
                        <Grid item xs={10}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Nombre</TableCell>
                                            <TableCell align="center">Documento</TableCell>
                                            <TableCell align="center">Estado de viabilidad</TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((row) => (
                                            <TableRow
                                                key={row.client.uuid}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="center">{row.client.name} {row.client.lastName}</TableCell>
                                                <TableCell align="center">{row.client.documentType} - {row.client.documentNumber}</TableCell>
                                                <TableCell align="center">{row.status}</TableCell>
                                                {row.status === "PRE_APPROVED" ? <TableCell align="center">
                                                    <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleQuotaSimulator(row.uuid, row.client.uuid)}>
                                                        Simulador de cuotas
                                                    </ButtonPrincipal>
                                                </TableCell> : null}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <br />
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={handleBackToHome}>
                                Volver
                            </ButtonPrincipal>
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </Box>
            </Container>
        </React.Fragment>
    );
}